import { Platform } from '../../common/creative/hooks/usePlatform';

export enum Layout {
  Unknown,
  Mobile,
  Desktop,
  MPUOneLine,
  MPUTwoLines,
}

export type LayoutMap<TValue = number> = { [key in Layout]: TValue };

export function useLayout(platform: Platform, adWidth: number, titleHasOneLine: boolean): Layout {
  if (platform === Platform.Unknown || adWidth < 1) {
    return Layout.Unknown;
  }

  if (adWidth === 300) {
    return titleHasOneLine ? Layout.MPUOneLine : Layout.MPUTwoLines;
  }

  return platform === Platform.Mobile ? Layout.Mobile : Layout.Desktop;
}
